import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { color } from 'theme/tokens/color'
import { textSizes } from 'theme/media'
import { mediaCSS } from 'blocks.app/config'
import { IStyles } from '../../../theme'

const deviceSettingsBrightnessStyles: IStyles = {
    wrapper: {
        ...grid.mt_mdPlus,
        ...grid.w100,
    },
    title: {
        fontSize: textSizes.normal,
    },
    timersWrapper: {
        position: 'relative',
        ...grid.p_mini,
        ...grid.col,
        ...grid.w20,
        marginRight: 14,
        marginBottom: 14,
        ...item.rounded_full_mini,
        backgroundColor: color.bgWhiteSecondary,
        width: 550,

        [mediaCSS.laptop]: {
            width: '48%',

            [mediaCSS.tab]: {
                marginRight: 0,

                [mediaCSS.tabMini]: {
                    ...grid.w100,
                },
            },
        },
    },
    content: {
        ...grid.row,
        ...grid.mt_md,

        [mediaCSS.tab]: {
            justifyContent: 'space-between',

            [mediaCSS.tabMini]: {
                ...grid.col,
            },
        },
    },
    removeIcon: {
        position: 'absolute',
        top: 10,
        right: 10,
    },
}

addStyles(deviceSettingsBrightnessStyles)
export default deviceSettingsBrightnessStyles
